import { Component, Input, OnInit } from "@angular/core";
import { RouterLink } from "@angular/router";
import { TranslateModule, TranslateService } from "@ngx-translate/core";
import { BvToastService } from "../../design-system";
import { ClubService } from "../../providers/club.service";
import { clubJoinUrl } from "../../shared/app-url";
import { QrCodeComponent } from "../../shared/qr-code/qr-code.component";
import { BvInputDirective } from "../../design-system/primitives/input.directive";
import { BvButtonComponent } from "../../design-system/primitives/button.component";
import { BvIconComponent } from "../../design-system/primitives/icon.component";

/**
 * The club's permanent link as a card: QR code, URL with copy, and a
 * "Print poster" button. Used by Club settings and the Add member dialog.
 * Project content (e.g. the join policy radio) renders under the link row.
 */
@Component({
  selector: "app-club-join-link",
  templateUrl: "./club-join-link.component.html",
  styleUrls: ["./club-join-link.component.scss"],
  imports: [RouterLink, TranslateModule, QrCodeComponent, BvInputDirective, BvButtonComponent, BvIconComponent],
})
export class ClubJoinLinkComponent implements OnInit {
  @Input() clubID?: string;
  @Input() qrSize = 112;
  url = "";

  constructor(
    private clubServ: ClubService,
    private translate: TranslateService,
    private toast: BvToastService
  ) {}

  ngOnInit() {
    this.url = clubJoinUrl(this.clubID || this.clubServ.clubID);
  }

  get id(): string {
    return this.clubID || this.clubServ.clubID;
  }

  copy() {
    navigator.clipboard
      ?.writeText(this.url)
      .then(() => {
        this.translate.get(["LINK_COPIED"]).subscribe((res: any) => {
          this.toast.open(res["LINK_COPIED"], undefined, { duration: 3000 });
        });
      })
      .catch(() => undefined);
  }
}
